import { observer } from 'mobx-react-lite';
import GeneralHome from './general-home';
import { URL_CONFIG } from '@/configs/environment';
import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { isPathEk } from '@/utils/routes';

export default observer(function HomePage() {
    const { pathname } = useLocation();

    const isEk = isPathEk(pathname);
    useEffect(() => {
        if (!isEk) {
            window.location.href = `${URL_CONFIG.DOMAIN_WORDPRESS.url}`;
        }
    }, []);

    // return
    // {
    //     isEk ? (
    //         <GeneralHome />

    //     ) : (

    //         <div className='h-[100vh]'></div>
    //     )

    //         ;
    // }

    const content = useMemo(() => {
        if (isEk) {
            return (
                <GeneralHome />
            );
        }
        return <div className='h-[100vh]'></div>;
    }, [isEk]);

    return <>{content}</>;
});
